window.theme = window.theme || {};

class ProductMainImages extends HTMLElement {
    constructor() {
      super();
  
      this.selectors = {
        thumb: '[js-thumbnail-slide]',
        mainCarousel: '[js-product-images]',
        showMoreThumbnailsBtn: '[js-show-more-thumbnails]',
        showLessThumbnailsBtn: '[js-show-less-thumbnails]'
      }
  
    }
  
    connectedCallback() {
        this.thumbs = this.querySelectorAll(this.selectors.thumb);
        this.mainCarousel = this.querySelector(this.selectors.mainCarousel);
        this.showMoreThumbnailsBtn = this.querySelector(this.selectors.showMoreThumbnailsBtn);
        this.showLessThumbnailsBtn = this.querySelector(this.selectors.showLessThumbnailsBtn);

        this._initListeners();
    }

    _initListeners() {
        this.thumbs.forEach(thumb => {
            thumb.addEventListener('click', this._handleThumbClick.bind(this));
        });

        this.mainCarousel.swiper.on("slideChangeTransitionStart", this._handleMainCarouselChange.bind(this));
        if (this.showLessThumbnailsBtn) {
            this.showLessThumbnailsBtn.style.display = 'none';
        }

        if (this.showMoreThumbnailsBtn) {
            this.showMoreThumbnailsBtn.addEventListener('click', this._handleShowMoreThumbnails.bind(this));
        }
        
        if (this.showLessThumbnailsBtn) {
            this.showLessThumbnailsBtn.addEventListener('click', this._handleShowLessThumbnails.bind(this));
        }
    }

    _handleMainCarouselChange() {
        this.thumbs.forEach(thumb => {
            thumb.classList.remove('active');
        });

        this.thumbs[this.mainCarousel.swiper.realIndex].classList.add('active');
    }

    _handleThumbClick(event) {
        const thumb = event.currentTarget;
        const index = thumb.dataset.index;
        this.mainCarousel.swiper.slideTo(index);

        this.thumbs.forEach(thumb => {
            thumb.classList.remove('active');
        });

        thumb.classList.add('active');
    }

    _handleShowMoreThumbnails() {
        const hiddenThumbnails = document.querySelectorAll('.hidden-thumbnail');
        hiddenThumbnails.forEach(thumbnail => {
            thumbnail.classList.remove('hidden-thumbnail');
        });

        this.showMoreThumbnailsBtn.style.display = 'none';
        if (this.showLessThumbnailsBtn) {
            this.showLessThumbnailsBtn.style.display = 'block';
        }
    }

    _handleShowLessThumbnails() {
        const allThumbnails = document.querySelectorAll('.thumbnail-slide');
        allThumbnails.forEach((thumbnail, index) => {
            if (index >= 4) {
                thumbnail.classList.add('hidden-thumbnail');
            }
        });

        this.showLessThumbnailsBtn.style.display = 'none';
        if (this.showMoreThumbnailsBtn) {
            this.showMoreThumbnailsBtn.style.display = 'block';
        }
    }
  }
  
customElements.define("s-product-images", ProductMainImages);
  

class ProductStickyAtc extends HTMLElement {
    constructor() {
        super();

    }

    connectedCallback() {
        let stickySection = document.querySelector('s-sticky-atc ');
        const stickyObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => 
          { 
            if (!entry.isIntersecting) {
              theme.utils.prepareTransition(stickySection);
              document.querySelector('body').classList.add('sticky-atc-shown');
            } else {
              theme.utils.prepareTransition(stickySection);
              document.querySelector('body').classList.remove('sticky-atc-shown');
            }
          });
        });
        stickyObserver.observe(document.querySelector('[js-main-product]'));

        const stickyAtcPrice = document.querySelector('[js-sticky-atc-add-to-cart]');
        const buyButton = document.querySelector('[js-product-form-submit]');
        stickyAtcPrice.addEventListener('click', () => {
          const sellingPlanInput = buyButton.closest('form').querySelector('input[name="selling_plan"]');
          if (sellingPlanInput) {
            sellingPlanInput.value = '';
          }
          
          buyButton.click();
        });
    }
}

customElements.define("s-sticky-atc", ProductStickyAtc);


class CartSubscription extends HTMLElement {
    constructor() {
        super();
        this.selectors = {
            updateCartButton: '[js-update-cart]',
            sCartSubscriptionSelect: '[js-s-cart-subscription-select]',
            sCartSubscriptionContent: '[js-s-cart-subscription-content]',
            sCartSubscriptionCheckbox: '[js-s-cart-subscription-checkbox]'
        }
    }

    connectedCallback() {
        this.updateCartButton = this.querySelectorAll(this.selectors.updateCartButton);
        this.sCartSubscriptionSelect = this.querySelector(this.selectors.sCartSubscriptionSelect);
        this.sCartSubscriptionContent = this.querySelector(this.selectors.sCartSubscriptionContent);
        this.sCartSubscriptionCheckbox = this.querySelector(this.selectors.sCartSubscriptionCheckbox);
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.updateCartButton.forEach(button => {
            button.addEventListener('click', this._submitUpdate.bind(this));
        });

        this.sCartSubscriptionSelect.addEventListener('change', this._handleSCartSubscriptionSelectChange.bind(this));
        this.sCartSubscriptionContent.addEventListener('click', this._handleSCartSubscriptionContentClick.bind(this));
    }

    _handleSCartSubscriptionContentClick(e) {
        e.preventDefault();
        this.sCartSubscriptionCheckbox.classList.toggle('active');
    }

    _handleSCartSubscriptionSelectChange(e) {
      this.updateCartButton.forEach(button => {
        button.dataset.sellingPlanId = e.currentTarget.value;
      });
    }


    _submitSingle(e) {
        e.preventDefault();
        let variantId = e.currentTarget.dataset.productId;
        let sellingPlanId = e.currentTarget.dataset.sellingPlanId;

        // Remove the current item from the cart
        let updates = {
          [variantId]: 0
        };
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates })
        })
        .then(response => {
          return response.json();
        })
        .then((response) => {
          // Add the new subscription item to the cart
          let data = {
            items: [{
              'id': variantId,
              'quantity': 1,
              'selling_plan': sellingPlanId
            }
          ],
            sections: this.getSectionsToRender().map((section) => section.section),

          };
      
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
          })
          .then((response) => response.json())
          .then((response) => {
            this.cart.renderContents(response);
          })
          .catch((error) => {
            console.error('Error:', error);
          });

        })
        .catch((error) => {
          console.error('Error:', error);
        });
        
    }

    _submitUpdate(e) {
      e.preventDefault();
      let lineId = e.currentTarget.dataset.lineId;
      let sellingPlanId = e.currentTarget.dataset.sellingPlanId;
      let quantity = e.currentTarget.dataset.quantity;

        // Add the new subscription item to the cart
        let data = {
          'id': lineId,
          'quantity': quantity,
          'selling_plan': sellingPlanId,
          sections: this.getSectionsToRender().map((section) => section.section)
        };

        fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
        .then((response) => response.json())
        .then((response) => {
          console.log('updateresponse', response);
          this.cart.renderContents(response);
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          section: 'cart-drawer',
          selector: '#CartDrawer',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
        },
        {
          id: 'cart-icon-qty',
          section: 'cart-icon-qty',
        },
      ];
    }
}

customElements.define("s-cart-subscription", CartSubscription);